export const DELIVERY_SERVICE_SDEK = "cdek"
export const DELIVERY_SERVICE_BOXBERRY = "boxberry"
export const DELIVERY_SERVICE_RUSSIAN_POST = "russian-post"

export const DELIVERY_TYPE_SELF_ID = 1
export const DELIVERY_TYPE_COURIER_ID = 2
export const DELIVERY_TYPE_PVZ_ID = 3
export const DELIVERY_TYPE_RUSSIAN_POST_ID = 4
export const DELIVERY_TYPE_TTK_ID = 5

// export const PAYMENT_TYPE_ONLINE_ID = 1
export const PAYMENT_TYPE_CASH_ID = 2